import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Utils from "../Utils";
import UserStorageManager from "./UserStorageManager";
import GoogleMapsLoader from "google-maps";
import { GOOGLE_MAPS_CONFIG, SUPORTED_MODEL_EXT } from "../constants";
import Amplify, { Auth, Storage } from "aws-amplify";
import { TextField, Input, Button } from "@material-ui/core/";
import GoogleMapsControl from "./GoogleMapsController";

import { withStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import InputLabel from "@material-ui/core/InputLabel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Icon from "@material-ui/core/Icon";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormHelperText from "@material-ui/core/FormHelperText";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Divider from "@material-ui/core/Divider";
import GoogleMapsWithControls from "./GoogleMapsWithControls";


import AppContext from "../AppContext";
import AlertDialog from "../AlertDialog";
import Fade from "@material-ui/core/Fade";
import JSONPretty from "react-json-pretty";
import { MUI_STYLES } from "../constants";
const styles = MUI_STYLES;
const LAT = 40.7308619;
const LNG = -73.9871558;
const ROT = 0;

Object.assign(GoogleMapsLoader, GOOGLE_MAPS_CONFIG);

export class AddProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: this.props.expanded,
      showSuccess: false,
      showFileName: false,
      showMap: false,
      note:"",
      projectName: "",
      lat: LAT,
      lng: LNG,
      rot: ROT,
      validations: this.initValidations(),
      file: {},
      invalid: true,
      loading: false,
      submitButton: "Send"
    };
    this.fileInput = React.createRef();
    this.markers = [];
    this.interacted = {};
    this.required = ["projectName", "file"];
  }

  componentDidMount() { }

  componentDidUpdate() {

  }

  setStateCallback = pData => {
    this.setState({
      changed: true,
      lat: pData.lat,
      lng: pData.lng,
      rot: pData.rot
    });
  };

  submit = async event => {
    // console.log("submit");
    event.preventDefault();

    this.setState({ loading: true });

    const file = this.fileInput.current.files[0];

    //console.log("awsconfig.Storage");
    let currentUserInfo = await Auth.currentUserInfo();
    let userMan = new UserStorageManager(Storage, currentUserInfo, this.props.awsStorageConfig);
    let db = await userMan.loadProjects();
    //console.log("Current User info:" + currentUserInfo);
    await userMan.uploadNewModel(
      db.projects.length,
      file,
      this.state.projectName,
      file.name,
      this.state.lat || LAT,
      this.state.lng || LNG,
      this.state.rot || ROT,
      this.state.description
    );

    this.resetForm();
    this.handleModalSwitch(true);
    this.props.saveAddCallback();
  };

  handleFileUpload = e => {

    this.interacted.file = !!this.fileInput.current.files[0];
    let validations = this.getValidations(this.state, this.interacted);
    let newState = Object.assign({}, this.state, validations);
    this.setState(newState);
    this.updateShownElements(this.interacted);
    //console.log(this.fileInput);
  };

  handleChange = name => event => {
    this.interacted[name] = true;
    let newState = {};
    Object.assign(newState, this.state, {
      [name]: event.target.value
    });



    let validations = this.getValidations(newState, this.interacted);

    Object.assign(newState, validations);
    this.setState(newState);
    this.updateShownElements(this.interacted);
  };

  initValidations = () => {
    return {
      projectName: new Utils.Validation(),
      note: new Utils.Validation(),
      file: new Utils.Validation(),
      invalid: true
    };
  };

  handleModalSwitch = value => {
    this.setState({ showSuccess: value });
  };

  updateShownElements = interacted => {
    this.setState({
      showProjectName: interacted.file,
      showMap: interacted.projectName
    });
  };

  getValidations = (state, interacted) => {
    let validations = {};
    Object.assign(validations, state.validations);

    if (interacted.file)
      validations.file = Utils.validateModel(this.fileInput.current.files[0]);

    if (interacted.projectName) {
      if (!state.projectName || !state.projectName.length === 0) {
        validations.projectName = new Utils.Validation(
          "Project name missing",
          "error"
        );
      } else if (state.projectName.length > 30) {
        validations.projectName = new Utils.Validation(
          "Project name length exceeded",
          "error"
        );
      } else {
        validations.projectName = new Utils.Validation();
      }
    }

    let interactedWithAllRequired = this.required.every(r => {
      return this.interacted[r];
    });

    validations.invalid = Object.values(validations).some(validation => {
      return validation.invalid;
    });

    return {
      validations: validations,
      invalid: validations.invalid || !interactedWithAllRequired
    };
  };

  resetForm = () => {
    this.setState({
      expanded: null,
      projectName: "",
      note:"",
      loading: false,
      showSuccess: false,
      showProjectName: false,
      showMap: false,
      lat: 0,
      lng: 0,
      rot: 0,
      validations: this.initValidations(),
      file: {},
      invalid: true,
      interacted: {}
    });
  };

  render() {
    const { classes } = this.props;
    const { handleExpandChange } = this.props;
    let validations = {};
    const { expanded } = this.props;

    return (
      <div className={classes.root}>
        <ExpansionPanel
          key="addPanel"
          expanded={expanded === "addPanel"}
          onChange={handleExpandChange({ projectKey: "addPanel" })}
        >
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className={classes.column} />
            <div className={classes.column}>
              <Typography className={classes.heading}>
                Add new Project
              </Typography>
            </div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.details}>
            <div className={classes.wideColumn}>
              <form
                onSubmit={this.submit}
                id="privateUploadForm"
                name="privateUploadForm"
                noValidate
                onKeyPress={event => {
                  if (event.which === 13 /* Enter */) {
                    event.preventDefault();
                  }
                }}
              >
                <FileInput
                  inputRef={this.fileInput}
                  onFileUpload={this.handleFileUpload}
                  classes={classes}
                  id="file-input"
                  error={this.state.validations.file.invalid}
                  helperText={this.state.validations.file.message}
                  accept={SUPORTED_MODEL_EXT}
                />
                <br />
                <Fade in={this.state.showProjectName}>
                  <TextField
                    id="standard-name"
                    label="Project name"
                    required
                    helperText={this.state.validations.projectName.message}
                    className={classes.textField}
                    value={this.state.projectName}
                    error={this.state.validations.projectName.invalid}
                    onChange={this.handleChange("projectName")}
                    margin="normal"
                    InputProps={{
                      required: true,
                      maxLength: 35
                    }}
                  />
                </Fade>

                <Fade in={this.state.showProjectName}>
                  <TextField
                      id="standard-name"
                      label="Note"
                      helperText={this.state.validations.note.message}
                      className={classes.textField}
                      value={this.state.note}
                      error={this.state.validations.note.invalid}
                      onChange={this.handleChange("note")}
                      margin="normal"
                      InputProps={{
                        required: true,
                        maxLength: 35
                      }}
                  />
                </Fade>

                <Fade in={this.state.showMap}>
                  <div>
                    <GoogleMapsWithControls
                      projectData={{
                        rot: this.state.rot,
                        lat: this.state.lat,
                        lng: this.state.lng
                      }}
                      defaultSetup={{ lat: 30, lng: 0, zoom: 4 }}
                      setStateCallback={this.setStateCallback}
                    />
                  </div>
                </Fade>

                <br />
              </form>
              {/*   <JSONPretty id="json-pretty" json={this.state} />
              <JSONPretty id="json-pretty" json={this.interacted} /> */}
            </div>
          </ExpansionPanelDetails>
          <Divider />
          <ExpansionPanelActions>
            <AdornedButton
              size="small"
              color="primary"
              variant="contained"
              className={classes.button}
              loading={this.state.loading}
              type="submit"
              disabled={this.state.invalid}
              form="privateUploadForm"
            />
          </ExpansionPanelActions>
        </ExpansionPanel>
        <AlertDialog
          title="Success"
          handleClose={() => {
            this.handleModalSwitch(false);
          }}
          open={this.state.showSuccess}
          description={
            <span>
              <p>
                Your model has been uploaded.
                <br /> You will get email notification after it is processed.
              </p>
            </span>
          }
        />
      </div>
    );
  }
}

AddProject.propTypes = {
  classes: PropTypes.object.isRequired
};
AddProject.contextType = AppContext;

export default withStyles(styles)(AddProject);

export function AdornedButton(props) {
  const { children, loading, classes, ...rest } = props;
  if (loading) return <CircularProgress size={20} />;
  return (
    <Button {...rest}>
      Upload &nbsp;&nbsp;
      <CloudUploadIcon />
    </Button>
  );
}

export function FileInput(props) {
  if (props.hide) return null;
  return (
    <div>
      <FormControl
        className={props.classes.formControl}
        error
        aria-describedby="component-error-text"
      >
        <input
          accept={props.accept}
          required={true}
          className={props.classes.input}
          style={{ display: "none" }}
          id={"file-input" + props.id}
          ref={props.inputRef}
          onChange={props.onFileUpload}
          type="file"
        />
        <label htmlFor={"file-input" + props.id}>
          <Button
            variant="contained"
            component="span"
            type="button"
            className={props.classes.button}
          >
            Select Your 3D file
          </Button>
        </label>
        <FormHelperText id="component-error-text">
          {props.helperText}
        </FormHelperText>
      </FormControl>
    </div>
  );
}

FileInput.propTypes = {
  classes: PropTypes.object.isRequired,
  onFileUpload: PropTypes.func.isRequired,
  inputRef: PropTypes.any.isRequired,
  id: PropTypes.any.isRequired,
  accept: PropTypes.string.isRequired
};
